import {screensStyle} from "./styles";

export const Line =({ height, minHeight }) =>{

    const classes = screensStyle()
    return(
        <div style={{height:height, minHeight: minHeight? minHeight : ''}} className={classes.lineStyle}/>
    )
}